import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config';
import './index.css';
import App from './App';
import { QuestionnaireProvider } from './context/QuestionnaireContext';
import { initializeAuth } from './services/api';
import reportWebVitals from './reportWebVitals';

// Initialize authentication on app start
initializeAuth().catch((error) => {
  console.error('Failed to initialize authentication:', error);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QuestionnaireProvider>
    <App />
    </QuestionnaireProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
